import { useState } from "react";
import { Table } from "react-bootstrap";

export function FilterButtonsTable({
  columns,
  setColumns
}) {
  const [photoStyle, setPhotoStyle] = useState("light");
  const [personnelTypeStyle, setPersonnelTypeStyle] = useState("light");
  const [tcKimlikNoStyle, setTcKkimlikNoStyle] = useState("light");
  const [nameStyle, setNameStyle] = useState("light");
  const [surnameStyle, setSurnameStyle] = useState("light");
  const [sexNameStyle, setSexNameStyle] = useState("light");
  const [birthDateStyle, setBirthDateStyle] = useState("light");
  const [birthPlaceStyle, setBirthPlaceStyle] = useState("light");
  const [maritalStatusNameStyle, setMaritalStatusNameStyle] = useState("light");
  const [mobilePhoneStyle, setMobilePhoneStyle] = useState("light");
  const [homePhoneStyle, setHomePhoneStyle] = useState("success");
  const [emailStyle, setEmailStyle] = useState("success");
  const [addressStyle, setAddressStyle] = useState("success");
  const [graduationTypeNameStyle, setGraduationTypeNameStyle] = useState("success");
  const [graduateUniversityStyle, setGraduateUniversityStyle] = useState("success");
  const [graduateDepartmentStyle, setGraduateDepartmentStyle] = useState("success");
  const [graduateGraduationYearStyle, setGraduateGraduationYearStyle] = useState("success");
  const [postGraduateUniversityStyle, setPostGraduateUniversityStyle] = useState("success");
  const [postGraduateDepartmentStyle, setPostGraduateDepartmentStyle] = useState("success");
  const [postGraduateGraduationYearStyle, setPostGraduateGraduationYearStyle] = useState("success");
  const [doctorateUniversityStyle, setDoctorateUniversityStyle] = useState("success");
  const [doctorateDepartmentStyle, setDoctorateDepartmentStyle] = useState("success");
  const [doctorateGraduationYearStyle, setDoctorateGraduationYearStyle] = useState("success");
  const [serviceYearStyle, setServiceYearStyle] = useState("success");
  const [workingYearInTheSchoolStyle, setWorkingYearInTheSchoolStyle] = useState("success");
  const [yearOfSeniorityStyle, setYearOfSeniorityStyle] = useState("success");
  const [formalContractStartDateStyle, setFormalContractStartDateStyle] = useState("success");
  const [formalContractEndDateStyle, setFormalContractEndDateStyle] = useState("success");
  const [contractStartDateStyle, setContractStartDateStyle] = useState("success");
  const [contractEndDateStyle, setContractEndDateStyle] = useState("success");
  const [insuranceNameStyle, setInsuranceNameStyle] = useState("success");
  const [insuranceStartDateStyle, setInsuranceStartDateStyle] = useState("success");
  const [insuranceEndDateStyle, setInsuranceEndDateStyle] = useState("success");
  const [formalSalaryStyle, setFormalSalaryStyle] = useState("success");
  const [salaryStyle, setSalaryStyle] = useState("success");
  const [bankStyle, setBankStyle] = useState("success");
  const [accountNoStyle, setAccountNoStyle] = useState("success");
  const [ibanStyle, setIbanStyle] = useState("success");

  /** */
  const setButtonStyle = (dataField) => {
    if (dataField === "photoStr") return setPhotoStyle;
    else if (dataField === "personnelType") return setPersonnelTypeStyle;
    else if (dataField === "tcKimlikNo") return setTcKkimlikNoStyle;
    else if (dataField === "name") return setNameStyle;
    else if (dataField === "surname") return setSurnameStyle;
    else if (dataField === "name") return setNameStyle;
    else if (dataField === "sexName") return setSexNameStyle;
    else if (dataField === "birthDate") return setBirthDateStyle;
    else if (dataField === "birthPlace") return setBirthPlaceStyle;
    else if (dataField === "maritalStatusName") return setMaritalStatusNameStyle;
    else if (dataField === "mobilePhone") return setMobilePhoneStyle;
    else if (dataField === "homePhone") return setHomePhoneStyle;
    else if (dataField === "email") return setEmailStyle;
    else if (dataField === "address") return setAddressStyle;
    else if (dataField === "graduationTypeName") return setGraduationTypeNameStyle;
    else if (dataField === "graduateUniversity") return setGraduateUniversityStyle;
    else if (dataField === "graduateDepartment") return setGraduateDepartmentStyle;
    else if (dataField === "graduateGraduationYear") return setGraduateGraduationYearStyle;
    else if (dataField === "postGraduateUniversity") return setPostGraduateUniversityStyle;
    else if (dataField === "postGraduateDepartment") return setPostGraduateDepartmentStyle;
    else if (dataField === "postGraduateGraduationYear") return setPostGraduateGraduationYearStyle;
    else if (dataField === "doctorateUniversity") return setDoctorateUniversityStyle;
    else if (dataField === "doctorateDepartment") return setDoctorateDepartmentStyle;
    else if (dataField === "doctorateGraduationYear") return setDoctorateGraduationYearStyle;
    else if (dataField === "serviceYear") return setServiceYearStyle;
    else if (dataField === "workingYearInTheSchool") return setWorkingYearInTheSchoolStyle;
    else if (dataField === "yearOfSeniority") return setYearOfSeniorityStyle;
    else if (dataField === "formalContractStartDate") return setFormalContractStartDateStyle;
    else if (dataField === "formalContractEndDate") return setFormalContractEndDateStyle;
    else if (dataField === "contractStartDate") return setContractStartDateStyle;
    else if (dataField === "contractEndDate") return setContractEndDateStyle;
    else if (dataField === "insuranceName") return setInsuranceNameStyle;
    else if (dataField === "insuranceStartDate") return setInsuranceStartDateStyle;
    else if (dataField === "insuranceEndDate") return setInsuranceEndDateStyle;
    else if (dataField === "formalSalary") return setFormalSalaryStyle;
    else if (dataField === "salary") return setSalaryStyle;
    else if (dataField === "bank") return setBankStyle;
    else if (dataField === "accountNo") return setAccountNoStyle;
    else if (dataField === "iban") return setIbanStyle;
  }

  /** */
  const toggleHidden = (dataField) => {
    const newColumns = [];

    columns.forEach(column => {
      const newColumn = {
        dataField: column.dataField,
        text: column.text,
        sort: column.sort,
        width: column.width,
        hidden: column.hidden,
        sortCaret: column.sortCaret,
        formatter: column.formatter,
        style: column.style
      };

      if (column.dataField === dataField) {
        newColumn.hidden = !column.hidden;
        setButtonStyle(dataField)(newColumn.hidden ? "success" : "light");
      }

      newColumns.push(newColumn);
    });    

    setColumns(newColumns);
  }  
  
  return (
    <div className="mt-5">
      <h5 className="card-label">Filtrele</h5>
      <Table hover>
        <tbody>
          <tr>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${photoStyle}`}
                onClick={() => toggleHidden("photoStr")}
              >
                Fotoğraf
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${personnelTypeStyle}`}
                onClick={() => toggleHidden("personnelType")}
              >
                Personel Türü
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${tcKimlikNoStyle}`}
                onClick={() => toggleHidden("tcKimlikNo")}
              >
                TC Kimlik No
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${nameStyle}`}
                onClick={() => toggleHidden("name")}
              >
                Adı
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${surnameStyle}`}
                onClick={() => toggleHidden("surname")}
              >
                Soyadı
              </button>
            </td>
          </tr>
          <tr>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${sexNameStyle}`}
                onClick={() => toggleHidden("sexName")}
              >
                Cinsiyeti
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${birthDateStyle}`}
                onClick={() => toggleHidden("birthDate")}
              >
                Doğum Tarihi
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${birthPlaceStyle}`}
                onClick={() => toggleHidden("birthPlace")}
              >
                Doğum Yeri
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${maritalStatusNameStyle}`}
                onClick={() => toggleHidden("maritalStatusName")}
              >
                Medeni Durumu
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${mobilePhoneStyle}`}
                onClick={() => toggleHidden("mobilePhone")}
              >
                Cep Telefonu
              </button>
            </td>
          </tr>
          <tr>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${homePhoneStyle}`}
                onClick={() => toggleHidden("homePhone")}
              >
                Ev Telefonu
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${emailStyle}`}
                onClick={() => toggleHidden("email")}
              >
                Email
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${addressStyle}`}
                onClick={() => toggleHidden("address")}
              >
                Adres
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${graduationTypeNameStyle}`}
                onClick={() => toggleHidden("graduationTypeName")}
              >
                Eğitim Durumu
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${graduateUniversityStyle}`}
                onClick={() => toggleHidden("graduateUniversity")}
              >
                Lisans Üniversitesi
              </button>
            </td>
          </tr>
          <tr>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${graduateDepartmentStyle}`}
                onClick={() => toggleHidden("graduateDepartment")}
              >
                Lisans Bölümü
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${graduateGraduationYearStyle}`}
                onClick={() => toggleHidden("graduateGraduationYear")}
              >
                Lisans Mezuniyet Yılı
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${postGraduateUniversityStyle}`}
                onClick={() => toggleHidden("postGraduateUniversity")}
              >
                Yüksek Lisans Üniversitesi
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${postGraduateDepartmentStyle}`}
                onClick={() => toggleHidden("postGraduateDepartment")}
              >
                Yüksek Lisans Bölümü
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${postGraduateGraduationYearStyle}`}
                onClick={() => toggleHidden("postGraduateGraduationYear")}
              >
                Yüksek Lisans Mezuniyet Yılı
              </button>
            </td>
          </tr>
          <tr>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${doctorateUniversityStyle}`}
                onClick={() => toggleHidden("doctorateUniversity")}
              >
                Doktora Üniversitesi
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${doctorateDepartmentStyle}`}
                onClick={() => toggleHidden("doctorateDepartment")}
              >
                Doktora Bölümü
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${doctorateGraduationYearStyle}`}
                onClick={() => toggleHidden("doctorateGraduationYear")}
              >
                Doktora Mezuniyet Yılı
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${serviceYearStyle}`}
                onClick={() => toggleHidden("serviceYear")}
              >
                Hizmet Yılı
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${workingYearInTheSchoolStyle}`}
                onClick={() => toggleHidden("workingYearInTheSchool")}
              >
                Okulda Çalışma Yılı
              </button>
            </td>
          </tr>
          <tr>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${yearOfSeniorityStyle}`}
                onClick={() => toggleHidden("yearOfSeniority")}
              >
                Kıdem Yılı
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${formalContractStartDateStyle}`}
                onClick={() => toggleHidden("formalContractStartDate")}
              >
                Resmi Sözleşme Başlangıç Tarihi
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${formalContractEndDateStyle}`}
                onClick={() => toggleHidden("formalContractEndDate")}
              >
                Resmi Sözleşme Bitiş Tarihi
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${contractStartDateStyle}`}
                onClick={() => toggleHidden("contractStartDate")}
              >
                Sözleşme Başlangıç Tarihi
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${contractEndDateStyle}`}
                onClick={() => toggleHidden("contractEndDate")}
              >
                Sözleşme Bitiş Tarihi
              </button>
            </td>
          </tr>
          <tr>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${insuranceNameStyle}`}
                onClick={() => toggleHidden("insuranceName")}
              >
                Sigorta Türü
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${insuranceStartDateStyle}`}
                onClick={() => toggleHidden("insuranceStartDate")}
              >
                Sigorta Başlangıç Tarihi
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${insuranceEndDateStyle}`}
                onClick={() => toggleHidden("insuranceEndDate")}
              >
                Sigorta Bitiş Tarihi
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${formalSalaryStyle}`}
                onClick={() => toggleHidden("formalSalary")}
              >
                Resmi Maaşı
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${salaryStyle}`}
                onClick={() => toggleHidden("salary")}
              >
                Maaşı
              </button>
            </td>
          </tr>
          <tr>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${bankStyle}`}
                onClick={() => toggleHidden("bank")}
              >
                Banka
              </button>
            </td>
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${accountNoStyle}`}
                onClick={() => toggleHidden("accountNo")}
              >
                Hesap No
              </button>
            </td>            
            <td>
              <button
                type="button"
                className={`btn btn-sm btn-${ibanStyle}`}
                onClick={() => toggleHidden("iban")}
              >
                Iban
              </button>
            </td>
          </tr>
        </tbody>
      </Table>
    </div>
  );
}